<template>
  <div class="w-full flex items-center justify-center">
    <template v-if="$route.name === 'Chat'">
      <span class="py-1.5 text-white font-bold drop-shadow">
        {{ $t('for_you.creators_like', { username: creatorName ? creatorName.split(' ')[0] : '' }) }}
      </span>
    </template>

    <template v-else>
      <router-link
        class="feed-link py-1.5 post-shadow"
        exact-active-class="active-feed-link"
        to="/">
        {{ $t('posts.for_you') }}
      </router-link>

      <div class="border border-r border-l-0 border-gray-300 h-4 mx-1.5"/>

      <router-link
        class="feed-link py-1.5 relative post-shadow"
        exact-active-class="active-feed-link"
        to="/following">
        {{ $t('posts.following') }}

        <span
          v-if="newPostExist"
          class="absolute top-2 -right-2 block h-2 w-2 rounded-full bg-[#1CD4ED]"/>
      </router-link>
    </template>
  </div>
</template>

<script setup>
import { inject } from 'vue'
import { storeToRefs } from 'pinia'
import { usePostStore } from '@/stores/post'

const creatorName = inject('creatorName', null)

const postStore = usePostStore()

const { newPostExist } = storeToRefs(postStore)
</script>

<style scoped>
  .feed-link.active-feed-link {
    @apply text-white;
  }

  .feed-link {
    @apply text-gray-300;
  }
</style>
